import React, { useState } from 'react';
import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';
import { Dropdown } from 'primereact/dropdown';

/**
 * PreAccountingFilter
 * - GenericTableFilter görünümü verir
 * - İçeride customer/dealer dropdown (server search + filterTemplate) kullanır
 * - Başlangıçta açık gelir (initiallyOpen=true)
 */
const PreAccountingFilter = ({
    th,
    customerType,
    customerDropdown, // hook'tan gelen { key,value,options,placeholder,loading,filterTemplate,onShow,onChange,emptyMessage }
    onReset,
    onApply, // opsiyonel: Apply basınca ne olacak
    initiallyOpen = true
}) => {
    const [open, setOpen] = useState(initiallyOpen);

    const label = customerType === 0 ? th('preAccounting.customer') : th('preAccounting.dealer');

    const handleApply = () => {
        // Dropdown seçimi anında zaten liste çekiliyor; Apply sadece UI için.
        // Yine de istersen dışarıdan onApply geçir.
        if (onApply) onApply();
    };

    return (
        <div className="generic-table-filter mb-2">
            <div className="grid">
                <div className="col-12 md:col-6 flex justify-content-start">
                    <Button icon="pi pi-filter" label={th('filter.advancedFilter')} onClick={() => setOpen((p) => !p)} outlined={!open} style={{ minWidth: '120px' }} type="button" />
                </div>
            </div>

            {open && (
                <div className="mt-3">
                    <Divider />
                    <div className="text-xl font-medium mb-3">{th('filter.advancedFilters')}</div>

                    <div className="grid">
                        <div className="col-12 md:col-6 lg:col-3">
                            <div className="field mb-2 p-1">
                                <label htmlFor="preAccCustomer" className="block mb-1 text-sm">
                                    {label}
                                </label>

                                <Dropdown
                                    key={customerDropdown.key}
                                    id="preAccCustomer"
                                    value={customerDropdown.value}
                                    onChange={(e) => customerDropdown.onChange(e.value)}
                                    options={customerDropdown.options}
                                    optionLabel="label"
                                    optionValue="value"
                                    placeholder={customerDropdown.placeholder}
                                    className="w-full"
                                    filter
                                    filterTemplate={customerDropdown.filterTemplate}
                                    showClear
                                    loading={customerDropdown.loading}
                                    appendTo="self"
                                    emptyMessage={customerDropdown.emptyMessage}
                                    onShow={customerDropdown.onShow}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="flex justify-content-start mt-3">
                        <Button label={th('filter.reset')} icon="pi pi-refresh" className="p-button-outlined mr-2" onClick={onReset} type="button" />
                        <Button label={th('filter.apply')} icon="pi pi-check" onClick={handleApply} type="button" />
                    </div>
                </div>
            )}
        </div>
    );
};

export default PreAccountingFilter;
